var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('van-icon',{staticClass:"c_error",attrs:{"name":"warning-o"},on:{"click":function($event){return _vm.toast.fail(_vm.message)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }